/*
 * AuthenticatorWidget Messages
 *
 * This contains all the text for the AuthenticatorWidget component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.AuthenticatorWidget";

export default defineMessages(scope, {
  header: "This is the AuthenticatorWidget component!",
  emailButton: "Set up Email OTP",
  emailHeader: "Email OTP",
  emailDesc:
    "Uses a one-time passcode sent to your email to verify your identity during sign-in.",
  emailError: "Email OTP attempts exceeded.",
  appButton: "Set up Authenticator App",
  appHeader: "Authenticator App",
  appDesc:
    "Generates 2-Step verification codes on your mobile device. Compatible with Google Authenticator, Authy, and Microsoft Authenticator.",
  oktaButton: "Set up Okta Verify",
  oktaHeader: "Okta Verify",
  oktaDesc:
    "Okta Verify is an authentication app installed on your phone used to prove your identity.",
  phoneButton: "Set up Phone Authentication",
  phoneHeader: "Phone Authentication",
  phoneDesc: "Receive a message on your mobile device with a code to log in.",
  emailStatus: "Configured",
  emailStatusDesc: "Managed by your organization.",
  appStatus: "Configured",
  appStatusDesc:
    "Cannot be removed for 24 hours after this method is configured.",
  phoneStatus: "Configured",
  phoneStatusDesc:
    "Cannot be removed for 24 hours after this method is configured.",
  oktaStatus: "Configured",
  oktaStatusDesc:
    "Cannot be removed for 24 hours after this method is configured.",
  emailErrorButton: "Email Failed. Try again.",
  phoneButtonRemove: "Remove Phone Authentication",
  oktaButtonRemove: "Remove Okta Verify",
  appButtonRemove: "Remove Authenticator App",
  envappButtonRemove: "Remove Authenticator App",
  emailButtonRemove: "Remove Email Authentication",

  envappHeader: "Authenticator App",
  envappButton: "Set up Authenticator App",
  envapp: "Authenticator App",
  envappStatusDesc:
    "Cannot be removed for 24 hours after this method is configured.",
  envappStatus: "Configured",
  envappDesc:
    "Generates 2-Step verification codes on your mobile device. Compatible with most TOTP authenticator apps (e.g. Google Authenticator, Authy, Microsoft Authenticator).",
});
